/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum CorrespondenceType {
  SMS = 'sms',
  SMS_REPLY = 'sms_reply',
  EMAIL = 'email',
}
